import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogBody,
} from '@axa-asia/emma-stylesheet/lib/components/Dialog';
import CountryTelephoneNumber from '@axa-asia/emma-stylesheet/lib/components/CountryTelephoneNumber/CountryTelephoneNumber';
import { ChangeContactView } from '../../components/ChangeContactView';
import { isApp, resolveLocalizedText } from '../../../../utils';
import {
  getChangeMobileStepContext,
  getChangeMobileLabels,
  getFatcaFlag,
  getCrsFlag,
  getNewMobile,
  getCountryCode,
  getIsLoading,
} from '../../selectors/updateMobileSelector';
import { goto } from '../../../../actions/historyActions';
import { extractCountryCode } from '../../../../utils/common';
import './style.scss';
import { t } from '../../../../locales';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import {
  updateCrsFlag,
  updateFatcaFlag,
  updateNewMobile,
  updateMobileOtherPolices,
  updateSelectedList,
} from '../../actions/changeMobileAction';
import {
  getSelectedPolicy,
  getChangeContactPolicyCardsLength,
} from '../../selectors/changeContactSelector';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import LongLoadingView from '../../../../components/LongLoadingView';
import { POLICIES, LIFE_REGEX } from '../../constants/constants';
import loadingIcon from '../../../../assets/images/loading-white.png';
import browserHistory from '../../../../stores/browserHistory';
import helpSvg from '../../../../assets/images/functional-help-blue.svg';
import { controlTopbarOverlay } from '../../../../utils/AppUtils';
import { EmmaText } from '@axa-asia/emma-stylesheet';
import classNames from 'classnames';

export interface UpdateMobileContainerProps {
  changeMobileStepContext: any;
  changeMobileLabels: any;
  updateNewMobile: (mobile: string, countryCode: string) => void;
  updateFatcaFlag: (value: boolean) => void;
  updateCrsFlag: (value: boolean) => void;
  updateSelectedList: (selectedList: any[]) => any;
  onUpdateMobileOtherPolices: () => any;
  policyDetails: any;
  fatcaFlag: boolean | null;
  crsFlag: boolean | null;
  newMobile: string;
  countryCode: string;
  isLoading: boolean;
  policies: number;
}

type Modal = 'FATCAModal' | 'CRSModal' | 'DownloadModal';

export interface UpdateMobileContainerState {
  isShowFATCAModal: boolean;
  isShowCRSModal: boolean;
  isShowDownloadModal: boolean;
  isError: boolean;
  isSameNumber: boolean;
  allowChangeCountryCode: boolean;
  latestMobile: string;
  latestCountryCode: string;
}

const allCountryOption = [
  {
    optionTitle: '852',
    optionVal: '852',
  },
  {
    optionTitle: '853',
    optionVal: '853',
  },
  {
    optionTitle: '86',
    optionVal: '86',
  },
  {
    optionTitle: '886',
    optionVal: '886',
  },
];

// 1. LHK policy ? Ask FATCA question : country code fixed to be +852 with new number.
// 2. (Original number is empty || CRS question answer "Y") ? user can select new country code and see a hyperlink remark directing user to download
// 3. GHK/G4HK policy ? country code fixed to be +852 with new number.

export class UpdateMobileContainer extends Component<
  UpdateMobileContainerProps,
  UpdateMobileContainerState
> {
  constructor(props: UpdateMobileContainerProps) {
    super(props);
    const { policyDetails, fatcaFlag, crsFlag } = props;
    const { entityCode, mobile } = policyDetails;
    const isLifePolicy = LIFE_REGEX.test(entityCode);
    this.state = {
      isShowFATCAModal: isLifePolicy && fatcaFlag === null,
      isShowCRSModal: false,
      isShowDownloadModal: false,
      isError: false,
      isSameNumber: false,
      allowChangeCountryCode: !isLifePolicy
        ? false
        : !mobile
        ? true
        : !!crsFlag,
      latestMobile: '',
      latestCountryCode: '',
    };
  }

  isLifePolicy = LIFE_REGEX.test(this.props.policyDetails.entityCode);

  hideModal = (modal: Modal, isFlagOn = false) => {
    const { policyDetails, updateFatcaFlag, updateCrsFlag, crsFlag } =
      this.props;

    if (modal === 'FATCAModal') {
      if (policyDetails.mobile && crsFlag === null) {
        this.setState({ isShowCRSModal: true });
        controlTopbarOverlay(true);
      } else {
        controlTopbarOverlay(false);
      }
      updateFatcaFlag(isFlagOn);
      this.setState({ isShowFATCAModal: false });
    } else if (modal === 'CRSModal') {
      updateCrsFlag(isFlagOn);
      this.setState({ isShowCRSModal: false });
      controlTopbarOverlay(false);
    } else if (modal === 'DownloadModal') {
      this.setState({ isShowDownloadModal: false });
      controlTopbarOverlay(false);
    }
  };

  componentDidMount() {
    const {
      policyDetails,
      updateNewMobile,
      updateSelectedList,
      newMobile,
      fatcaFlag,
    } = this.props;

    updateSelectedList([]); // To clear selected policy list for user step back from applyToAll

    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    }

    const { mobile = '' } = policyDetails;
    const { countryCode } = extractCountryCode(mobile);
    const { latestMobile, latestCountryCode } = this.state;

    // Country code is empty when existing number is not HK/MO/CN/TW
    if (mobile && countryCode === '') {
      this.setState({
        isShowDownloadModal: true,
        isShowFATCAModal: false,
      });
      controlTopbarOverlay(true);
    } else if (mobile && this.isLifePolicy && !newMobile) {
      updateNewMobile(newMobile, countryCode);
    }

    if (
      latestMobile != newMobile ||
      latestCountryCode != this.props.countryCode
    ) {
      this.setState({
        latestMobile: newMobile,
        latestCountryCode: this.props.countryCode,
      });
    }

    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_UPDATE_MOBILE_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }

    if (this.isLifePolicy && fatcaFlag === null) {
      controlTopbarOverlay(true);
    }

    // registerHistoryIndex(CHANGE_MOBILE_EDIT_ID);
  }

  onChangeNewNumber = ({
    countryValue,
    value,
    isError,
  }: {
    countryValue: string;
    value: string;
    isError: boolean;
  }) => {
    const { policyDetails } = this.props;
    const {
      countryCode: oldCountryCode,
      mobileNumber: oldNumber,
    }: { countryCode: string; mobileNumber: string } = extractCountryCode(
      policyDetails.mobile,
    );

    // updateNewMobile(value, countryValue);
    this.setState({
      isSameNumber:
        oldCountryCode === countryValue && oldNumber === value && value !== '',
      isError,
      latestMobile: value,
      latestCountryCode: countryValue,
    });
  };

  onSubmit = () => {
    const { latestMobile, latestCountryCode } = this.state;
    const { onUpdateMobileOtherPolices, updateNewMobile } = this.props;

    updateNewMobile(latestMobile, latestCountryCode);
    onUpdateMobileOtherPolices();
  };

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const {
      changeMobileStepContext,
      changeMobileLabels,
      policyDetails,
      countryCode,
      newMobile,
      isLoading,
      crsFlag,
      policies,
    } = this.props;
    const oldNumber: string = policyDetails.mobile || '';
    const {
      editMobileTitle,
      editMobile,
      editNewMobile,
      mobileErrMsg,
      sameMobileErrMsg,
      nextBtnLabel,
      countryCodePlaceholder,
      yes,
      no,
      downloadBtn,
      cancelBtn,
      fatcaModalTitle,
      crsModalTitle,
      downloadModalTitle,
      downloadModalContent,
      downloadUrl,
      countryCodeReminder,
      inputMobilePlaceholder,
      remarksLabel,
    } = changeMobileLabels;

    const {
      isShowFATCAModal,
      isShowCRSModal,
      isShowDownloadModal,
      isError,
      isSameNumber,
      allowChangeCountryCode,
      latestMobile,
      latestCountryCode,
    } = this.state;
    const resolvedStepContext = resolveLocalizedText(
      changeMobileStepContext,
    ) as any;

    const extractedOldNumber = extractCountryCode(oldNumber);
    const existingCountryCode = extractedOldNumber.countryCode || '852',
      existingMobileNumber = extractedOldNumber.mobileNumber;
    const disabledBtn =
      !latestCountryCode ||
      !latestMobile ||
      isError ||
      isSameNumber ||
      isLoading;
    const options = crsFlag
      ? allCountryOption.filter(
          (option) => option.optionVal !== existingCountryCode,
        )
      : allCountryOption;

    return (
      <div className="update-mobile">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={
            editMobileTitle ? resolveLocalizedText(editMobileTitle) : ''
          }
          stepContext={resolvedStepContext}
          activeIndex={0}
        >
          {isLoading ? (
            <LongLoadingView isShowText={policies > POLICIES} />
          ) : (
            <div className="update-mobile-container emma-stylesheet-grid-system">
              {oldNumber && (
                <div className="row mobile-num-wrapper">
                  <div className="col-12 mobile-num-label">
                    {editMobile ? resolveLocalizedText(editMobile) : ''}
                  </div>
                  <div className="col-12 mobile-num-input">
                    <CountryTelephoneNumber
                      countryCode={existingCountryCode}
                      countryOption={allCountryOption}
                      errorMessage={
                        mobileErrMsg ? resolveLocalizedText(mobileErrMsg) : ''
                      }
                      isValidateInitValue={false}
                      placeholder={
                        inputMobilePlaceholder
                          ? resolveLocalizedText(inputMobilePlaceholder)
                          : ''
                      }
                      dropdownPlaceholder={t(
                        'COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER',
                      )}
                      hideDropdown={!this.isLifePolicy}
                      disabled={true}
                      disabledDropdown={true}
                      mobileValue={existingMobileNumber}
                    />
                  </div>
                </div>
              )}
              <div className="row mobile-num-wrapper">
                <div className="col-12 mobile-num-label">
                  {editNewMobile ? resolveLocalizedText(editNewMobile) : ''}
                </div>
                <div
                  className={`col-12 mobile-num-input ${
                    isSameNumber ? 'same-number-error' : ''
                  }`}
                >
                  <CountryTelephoneNumber
                    mobileValue={newMobile}
                    countryCode={
                      _.find(options, ['optionVal', countryCode])
                        ? countryCode
                        : options[0].optionVal
                    }
                    countryOption={options}
                    errorMessage={
                      mobileErrMsg ? resolveLocalizedText(mobileErrMsg) : ''
                    }
                    isValidateInitValue={!!newMobile}
                    onChange={this.onChangeNewNumber}
                    placeholder={
                      inputMobilePlaceholder
                        ? resolveLocalizedText(inputMobilePlaceholder)
                        : ''
                    }
                    dropdownPlaceholder={t(
                      'COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER',
                    )}
                    disabledDropdown={!allowChangeCountryCode}
                  />
                  {isSameNumber && (
                    <div className="custom-error-wrapper">
                      {sameMobileErrMsg
                        ? resolveLocalizedText(sameMobileErrMsg)
                        : ''}
                    </div>
                  )}
                </div>
                <p className={EmmaText['Remarks_Error/Loose/Left/MineShaft']}>
                  {remarksLabel && resolveLocalizedText(remarksLabel)}
                </p>
              </div>
              <div className="row">
                <button
                  data-enable-ga
                  data-ga-type="button"
                  disabled={disabledBtn}
                  className={
                    disabledBtn
                      ? 'emma-stylesheet-primary-secondary-default-disabled-button'
                      : 'emma-stylesheet-primary-default-button'
                  }
                  onClick={this.onSubmit}
                >
                  {isLoading && <img src={loadingIcon} alt="loading" />}
                  {nextBtnLabel ? resolveLocalizedText(nextBtnLabel) : ''}
                </button>
              </div>
              {crsFlag && (
                <div className="row msg-wrapper">
                  <div className="col-2">
                    <img src={helpSvg} alt="help" />
                  </div>
                  <div
                    className="col-10 cs-help-msg"
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(
                        countryCodeReminder
                          ? resolveLocalizedText(countryCodeReminder)
                          : '',
                      ),
                    }}
                  ></div>
                </div>
              )}
            </div>
          )}
        </ChangeContactView>
        <Dialog show={isShowFATCAModal}>
          <DialogHeader>
            <span>
              {fatcaModalTitle ? resolveLocalizedText(fatcaModalTitle) : ''}
            </span>
          </DialogHeader>
          <DialogFooter>
            <div>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button mt8"
                onClick={() => this.hideModal('FATCAModal', true)}
              >
                {yes ? resolveLocalizedText(yes) : ''}
              </button>
            </div>
            <div>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button mt8"
                onClick={() => this.hideModal('FATCAModal', false)}
              >
                {no ? resolveLocalizedText(no) : ''}
              </button>
            </div>
          </DialogFooter>
        </Dialog>
        <Dialog show={isShowCRSModal}>
          <DialogHeader>
            <span>
              {crsModalTitle ? resolveLocalizedText(crsModalTitle) : ''}
            </span>
          </DialogHeader>
          <DialogFooter>
            <div>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button mt8"
                onClick={() => {
                  this.hideModal('CRSModal', true);
                  this.setState({ allowChangeCountryCode: true });
                }}
              >
                {yes ? resolveLocalizedText(yes) : ''}
              </button>
            </div>
            <div>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button mt8"
                onClick={() => {
                  this.hideModal('CRSModal', false);
                  this.setState({ allowChangeCountryCode: false });
                }}
              >
                {no ? resolveLocalizedText(no) : ''}
              </button>
            </div>
          </DialogFooter>
        </Dialog>
        <Dialog show={isShowDownloadModal}>
          <DialogHeader>
            <span>
              {downloadModalTitle
                ? resolveLocalizedText(downloadModalTitle)
                : ''}
            </span>
          </DialogHeader>
          <DialogBody>
            <div className="download-modal-content">
              {downloadModalContent
                ? resolveLocalizedText(downloadModalContent)
                : ''}
            </div>
          </DialogBody>
          <DialogFooter>
            <a target="_blank" rel="noopener noreferrer" href={downloadUrl}>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-default-button"
              >
                {downloadBtn ? resolveLocalizedText(downloadBtn) : ''}
              </button>
            </a>
            <button
              data-enable-ga
              data-ga-type="button"
              className="emma-stylesheet-primary-ghost-button mt8"
              onClick={() => {
                this.hideModal('DownloadModal');
                browserHistory.goBack();
              }}
            >
              {cancelBtn ? resolveLocalizedText(cancelBtn) : ''}
            </button>
          </DialogFooter>
        </Dialog>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any) {
    const changeMobileStepContext = getChangeMobileStepContext(state);
    const changeMobileLabels = getChangeMobileLabels(state);
    const policyDetails = getSelectedPolicy(state);
    const fatcaFlag: boolean | null = getFatcaFlag(state);
    const crsFlag: boolean | null = getCrsFlag(state);
    const newMobile = getNewMobile(state);
    const countryCode = getCountryCode(state);
    const isLoading = getIsLoading(state);
    const policies = getChangeContactPolicyCardsLength(state);
    return {
      changeMobileStepContext,
      changeMobileLabels,
      policyDetails,
      fatcaFlag,
      crsFlag,
      newMobile,
      countryCode,
      isLoading,
      policies,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateNewMobile: (newMobile: string, countryCode: string) =>
        dispatch(updateNewMobile(newMobile, countryCode)),
      updateFatcaFlag: (value: boolean) => dispatch(updateFatcaFlag(value)),
      updateCrsFlag: (value: boolean) => dispatch(updateCrsFlag(value)),
      onUpdateMobileOtherPolices: () => dispatch(updateMobileOtherPolices()),
      updateSelectedList: (selectedList: any[]) =>
        dispatch(updateSelectedList(selectedList)),
    };
  }
}

export default connect(
  UpdateMobileContainer.mapStateToProps,
  UpdateMobileContainer.mapDispatchToProps,
)(UpdateMobileContainer);
